
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_5a145_154lc_5",
  "icon-swap": "awsui_icon-swap_5a145_154lc_9",
  "icon-swap-copy": "awsui_icon-swap-copy_5a145_154lc_14",
  "icon-swap-result": "awsui_icon-swap-result_5a145_154lc_15",
  "icon-swap-copied": "awsui_icon-swap-copied_5a145_154lc_47",
  "popover-message": "awsui_popover-message_5a145_154lc_73",
  "inline-container": "awsui_inline-container_5a145_154lc_77",
  "inline-container-trigger": "awsui_inline-container-trigger_5a145_154lc_80",
  "inline-container-no-wrap": "awsui_inline-container-no-wrap_5a145_154lc_83",
  "text-to-display": "awsui_text-to-display_5a145_154lc_92"
};
  